// Créez un nouveau fichier src/lib/gtag.ts
export const GA_TRACKING_ID = 'G-434H20VH4H'

// Déclaration des types pour TypeScript
declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}

// Fonction pour initialiser GA
export const initGA = () => {
  const script1 = document.createElement('script')
  script1.async = true
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`

  const script2 = document.createElement('script')
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_TRACKING_ID}');
  `

  document.head.appendChild(script1)
  document.head.appendChild(script2)
}

// Fonction pour envoyer un pageview
export const pageview = (url: string) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
}
